"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var uniqueId = require("lodash.uniqueid");

var Prescription02 =
/** @class */
function (_super) {
  __extends(Prescription02, _super);

  function Prescription02() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.filter1 = uniqueId('react-filter-');
    return _this;
  }

  Prescription02.prototype.render = function () {
    var filter1 = this.filter1;
    return React.createElement("g", {
      id: 'Top/_Resources/Prescription-02',
      fill: 'none',
      transform: 'translate(62.000000, 85.000000)',
      strokeWidth: '1'
    }, React.createElement("defs", null, React.createElement("filter", {
      x: '-0.8%',
      y: '-2.4%',
      width: '101.5%',
      height: '109.8%',
      filterUnits: 'objectBoundingBox',
      id: filter1
    }, React.createElement("feOffset", {
      dx: '0',
      dy: '2',
      in: 'SourceAlpha',
      result: 'shadowOffsetOuter1'
    }), React.createElement("feColorMatrix", {
      values: '0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0',
      type: 'matrix',
      in: 'shadowOffsetOuter1',
      result: 'shadowMatrixOuter1'
    }), React.createElement("feMerge", null, React.createElement("feMergeNode", {
      in: 'shadowMatrixOuter1'
    }), React.createElement("feMergeNode", {
      in: 'SourceGraphic'
    })))), React.createElement("g", {
      id: 'Wayfarers',
      filter: "url(#" + filter1 + ")",
      transform: 'translate(6.000000, 7.000000)',
      fill: '#252C2F'
    }, React.createElement("path", {
      d: 'M34,41 L31.2421498,41 C17.3147125,41 9,33.3359286 9,20.5 C9,10.127 10.8170058,0 32.5299306,0 L35.4700694,0 C57.1829942,0 59,10.127 59,20.5 C59,32.5686429 48.7212748,41 34,41 Z M32.3853606,6 C13,6 13,12.8410159 13,21.5015498 C13,28.5719428 16.116254,37 30.9709365,37 L34,37 C46.3649085,37 55,30.6270373 55,21.5015498 C55,12.8410159 55,6 35.6146394,6 L32.3853606,6 Z',
      id: 'Left',
      fillRule: 'nonzero'
    }), React.createElement("path", {
      d: 'M96,41 L93.2421498,41 C79.3147125,41 71,33.3359286 71,20.5 C71,10.127 72.8170058,0 94.5299306,0 L97.4700694,0 C119.182994,0 121,10.127 121,20.5 C121,32.5686429 110.721275,41 96,41 Z M94.3853606,6 C75,6 75,12.8410159 75,21.5015498 C75,28.5719428 78.1194833,37 92.9709365,37 L96,37 C108.364909,37 117,30.6270373 117,21.5015498 C117,12.8410159 117,6 97.6146394,6 L94.3853606,6 Z',
      id: 'Right',
      fillRule: 'nonzero'
    }), React.createElement("path", {
      d: 'M2.95454545,5.77156439 C3.64590909,5.09629136 11.2095455,0 32.5,0 C50.3513636,0 54.1302273,1.85267217 59.8502273,4.6518809 L60.2689233,4.85850899 C60.6666014,4.99901896 62.7002447,5.68982981 65.0790606,5.76579519 C67.2462948,5.67278567 69.1000195,5.08540191 69.641698,4.89719767 C76.1703915,1.7220864 82.5610971,0 97.5,0 C118.790455,0 126.354091,5.09629136 127.045455,5.77156439 C128.679318,5.77156439 130,7.06150904 130,8.65734659 L130,11.5431288 C130,13.1389663 128.679318,14.428911 127.045455,14.428911 C127.045455,14.428911 120.143997,14.428911 120.143997,17.3146932 C120.143997,20.2004754 118.181818,13.1389663 118.181818,11.5431288 L118.181818,8.73240251 C114.578575,7.35340151 108.128411,4.78617535 97.5,4.78617535 C85.6584651,4.78617535 79.7610984,6.88602813 74.7022935,8.97112368 L74.7588636,9.10752861 L74.7563667,11.0937608 L72.5391666,16.4436339 L69.8004908,15.3608351 C69.5558969,15.2641292 69.0281396,15.090392 68.2963505,14.9099044 C66.256272,14.4067419 64.1589087,14.253569 62.3040836,14.6343084 C61.6235903,14.7739931 60.9922286,14.9836085 60.4128127,15.266732 L57.7704824,16.5578701 L55.1266751,11.3962031 L55.2440909,9.10175705 L55.3248203,8.90683855 C50.9620526,6.87386374 46.9392639,4.78617535 32.5,4.78617535 C21.8721459,4.78617535 15.422131,7.3524397 11.8181818,8.7314671 L11.8181818,11.5431288 C11.8181818,13.1389663 8.86363636,20.2004754 8.86363636,17.3146932 C8.86363636,14.428911 2.95454545,14.428911 2.95454545,14.428911 C1.32363636,14.428911 0,13.1389663 0,11.5431288 L0,8.65734659 C0,7.06150904 1.32363636,5.77156439 2.95454545,5.77156439 Z',
      id: 'Stuff',
      fillRule: 'nonzero'
    })));
  };

  Prescription02.optionValue = 'Prescription02';
  return Prescription02;
}(React.Component);

exports.default = Prescription02;